import { AccountType } from './user.type.constants'

export enum LoanStatusType {
  PREQUAL = 'prequal',
  APPSIGNED = 'appSigned',
  RESTRUCTURERELEASE = 'restructureRelease',
  LOAN_INTAKE_REVIEW = 'inTakeReview',
  LOAN_SETUP_ON_HOLD = 'loanSetupOnHold',
  APPLICATION = 'application',
  SUBMITTED = 'submitted',
  SUSPENDED = 'suspended',
  APPROVED = 'approved',
  RE_SUBMITTED = 'reSubmitted',
  UNDERWRITER_REVIEW = 'underwriterReview',
  DECLINED = 'declined',
  CLEAR_TO_CLOSE = 'clearToClose',
  READY_FOR_DOCS = 'readyForDocs',
  DOCS_OUT = 'docsOut',
  CLOSED = 'closed',
  CLOSEDLOANREVIEW = 'closedLoanReview',
  READYFORPURCHASE = 'readyForPurchase',
  FUNDED = 'funded',
  WITHDRAWN = 'withdrawn',
}

export const loanStatusConstants: {
  loanSetupUnHoldStatus: string[]
  closeStatus: string[]
  archivedStatus: string[]
  activeStatus: string[]
  suspendedStatus: string[]
  brokerCanResubmitConditions: string[]
  servicingStatus: Record<string, string>
} = {
  loanSetupUnHoldStatus: [],
  closeStatus: [],
  archivedStatus: [],
  activeStatus: [],
  suspendedStatus: [],
  brokerCanResubmitConditions: [],
  servicingStatus: {
    servicing: 'Servicing',
    reo: 'REO',
    purchased: 'Purchased',
    paidInFull: 'Paid in Full',
  },
}

export const defaultLoanServicingStatusKeys = Object.keys(loanStatusConstants.servicingStatus)

export const setLoanServicingStatus = (data: Record<string, string>) => {
  loanStatusConstants.servicingStatus = data
}

export interface ILoanStatusConfig {
  fromPermission: AccountType[]
  toPermission: AccountType[]
  new: string
  origin: string
  use: boolean

  isActive?: boolean
  isArchived?: boolean
  isClose?: boolean
  isLoanSetupUnhold?: boolean
  isSuspended?: boolean
  isBrokerCanResubmitConditions?: boolean
  isIncludedCalculation?: boolean
}

export const setLoanStatusConfig = (data: Record<string, ILoanStatusConfig>) => {
  const activeStatus = Object.keys(data).filter((key) => data[key].use)

  loanStatusConstants.loanSetupUnHoldStatus = activeStatus.filter((key) => data[key].isLoanSetupUnhold)
  loanStatusConstants.closeStatus = activeStatus.filter((key) => data[key].isClose)
  loanStatusConstants.archivedStatus = activeStatus.filter((key) => data[key].isArchived)
  loanStatusConstants.activeStatus = activeStatus.filter((key) => data[key].isActive)
  loanStatusConstants.suspendedStatus = activeStatus.filter((key) => data[key].isSuspended)
  loanStatusConstants.brokerCanResubmitConditions = activeStatus.filter(
    (key) => data[key].isBrokerCanResubmitConditions,
  )
}
